// extracted by mini-css-extract-plugin
module.exports = {"container":"pages-error-container","title":"pages-error-title","description":"pages-error-description","actions":"pages-error-actions"};